import { render, staticRenderFns } from "./resourceDetailItemOut.vue?vue&type=template&id=534995aa&scoped=true"
import script from "./resourceDetailItemOut.vue?vue&type=script&lang=js"
export * from "./resourceDetailItemOut.vue?vue&type=script&lang=js"
import style0 from "./resourceDetailItemOut.vue?vue&type=style&index=0&id=534995aa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "534995aa",
  null
  
)

export default component.exports